import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { CreateAdoProject } from './CreateAdoProjectExtension';

export const CreateAdoProjectFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CreateAdoProject',
    component: CreateAdoProject,
  }),
);
